import { TypeOfColumn } from 'v2/utils/searchViewUtils';
import Conversations from './Conversations';
import DateCreated from './DateCreated';
import Originator from './Originator';
import OriginatorDetailed from './OriginatorDetailed';
import Responses from './Responses';
import Reviewer from './Reviewer';
import SearchType from './SearchType';
import Title from './Title';
import TitleDetailed from './TitleDetailed';
import ReviewStatus from './ReviewStatus';
import LastActivity from './LastActivity';

const columnByType = {
  [TypeOfColumn.title]: Title,
  [TypeOfColumn.titleDetailed]: TitleDetailed,
  [TypeOfColumn.originator]: Originator,
  [TypeOfColumn.originatorDetailed]: OriginatorDetailed,
  [TypeOfColumn.reviewStatus]: ReviewStatus,
  [TypeOfColumn.reviewer]: Reviewer,
  [TypeOfColumn.searchType]: SearchType,
  [TypeOfColumn.responses]: Responses,
  [TypeOfColumn.conversations]: Conversations,
  [TypeOfColumn.dateCreated]: DateCreated,
  [TypeOfColumn.lastActivity]: LastActivity,
};

export default columnByType;
